import ReportCard from "design/components/cards/ReportCard";
import React from "react";
import { makeStyles } from "@material-ui/core";
import StrategyIcon from "assets/StrategyIcon";
import { ICardElementWithChildren } from "backend/model/model";
import ElementIcon from "design/components/icons/ElementIcon";
import useElement from "backend/hooks/elements/useElement";
import useLevelName from "backend/hooks/misc/useLevelName";
import { useSelectedReportContext } from "state/SelectedReportContext";

const useStyle = makeStyles({
  cards: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
});

const DivisionReport = (
  props: React.PropsWithChildren<{ item: ICardElementWithChildren }>
) => {
  const styles = useStyle();
  const { item } = props;
  const { data: topElement } = useElement(item.topelement);
  const reportSelection = useSelectedReportContext();
  const levelName = useLevelName(item.level);
  if (!topElement) {
    return null;
  }
  return (
    <ReportCard
      icon={<ElementIcon item={item} size={50} />}
      title={`${levelName} Report`}
      isOpen={reportSelection.report?.id === item.id}
      onChange={(val) => {
        if (reportSelection.report?.id === item.id) {
          reportSelection.clearReport();
          return;
        }

        reportSelection.setReport({
          ...item,
          reportType: {
            name: `Performance Report`,
            reportType: "divisionreport",
          },
        });
      }}
    />
  );
};

export default DivisionReport;
